import * as React from 'react';
import calculateScrollOffset from '../../utils/calculateScrollOffset';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { areDateRangesEqual, DateRange } from 'owa-datetime-utils';

/**
 * ScrollToWorkingHoursBehavior properties
 */
export interface ScrollToWorkingHoursBehaviorProps {
    store: CalendarSurfaceStore;
}

/**
 * Scrolls attached element to pixel offset of working hours start
 */
export class ScrollToWorkingHoursBehavior extends React.Component<
    ScrollToWorkingHoursBehaviorProps,
    {}
> {
    private container: HTMLElement;
    private cachedDateRange: DateRange;

    onAttach(el: HTMLElement) {
        this.container = el;
        this.scrollToWorkingHours();
    }

    componentDidUpdate() {
        this.scrollToWorkingHours();
    }

    render() {
        return null;
    }

    private scrollToWorkingHours() {
        let { store } = this.props;
        if (!areDateRangesEqual(this.cachedDateRange, store.dateRange)) {
            this.cachedDateRange = store.dateRange;
            this.container && (this.container.scrollTop = calculateScrollOffset(store));
        }
    }
}
